const state = {
  //���Y
  MasterGUID: null,
  PartNumber: null,
  ProductName: null, //�~�W
  GUInumber: null, //�t�ӱb��(�νs)
  SupplierName: null, //�t�ӦW��
  State: null,
  Classification: null,
  Remark: null,
  CreateUser: null,
  CreateDate: null,
  ModifyUser: null,
  ModifyDate: null,
  Company: null,
  //�樭
  Details: [],
  DeleteDetails: [],
  Industry: null, //�~�O
  IndustryName: null, //�~�O�W��
  InduItem: [], //�~�O�Ӷ�
  //Show
  isEdit: false,
  isShowReport: false,
};
const mutations = {
  SetCompany(state, val) {
    state.Company = val;
  },
  SetIndustry(state, item) {
    state.Industry = item;
  },
  SetIndustryName(state, name) {
    state.IndustryName = name;
  },
  SetInduItem(state, item) {
    state.InduItem = item;
  },
  SetDetails(state, item) {
    state.Details = item;
  },
  SetDeleteDetails(state, item) {
    state.DeleteDetails = item;
  },
  //
  SetClassification(state, val) {
    state.Classification = val;
  },
  SetState(state, enable) {
    state.State = enable;
  },
  SetPartNumber(state, num) {
    state.PartNumber = num;
  },
  SetMasterGUID(state, GUID) {
    state.MasterGUID = GUID;
  },
  SetProductName(state, name) {
    state.ProductName = name;
  },
  SetGUInumber(state, num) {
    state.GUInumber = num;
  },
  SetSupplierName(state, name) {
    state.SupplierName = name;
  },
  SetCreateUser(state, user) {
    state.CreateUser = user;
  },
  SetCreateDate(state, date) {
    state.CreateDate = date;
  },
  SetModifyUser(state, user) {
    state.ModifyUser = user;
  },
  SetModifyDate(state, date) {
    state.ModifyDate = date;
  },

  SetisEdit(state, bool) {
    state.isEdit = bool;
  },
  SetisShowReport(state, bool) {
    state.isShowReport = bool;
  },
};
const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
